import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Container, Reveal, Eyebrow, Btn } from './landing/primitives';

const FinalCTA = () => {
  const navigate = useNavigate();
  return (
    <section className="py-28 lg:py-40 border-t border-line relative overflow-hidden" data-testid="final-cta-section">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: 'radial-gradient(ellipse 50% 60% at 80% 100%, var(--c-overlay-strong), transparent 70%)' }}
      />
      <Container className="relative">
        <Reveal className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <Eyebrow>Get started</Eyebrow>
            <h2 className="mt-6 text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-heading font-medium tracking-tight leading-[1.0] text-content" data-testid="final-cta-headline">
              Ready to build on<br />sovereign intelligence?
            </h2>
          </div>
          <div className="lg:col-span-4 lg:pb-2">
            <p className="text-content-2 text-base leading-relaxed">
              Start chatting in seconds, or talk to us about an enterprise deployment tailored to your stack.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Btn onClick={() => navigate('/chat')} data-testid="final-cta-get-started-btn">
                Get Started Free <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
              </Btn>
              <Btn variant="secondary" onClick={() => navigate('/docs')} data-testid="final-cta-docs-btn">Explore platform</Btn>
            </div>
          </div>
        </Reveal>
      </Container>
    </section>
  );
};

export default FinalCTA;
